import { render, staticRenderFns } from "./noticePage.vue?vue&type=template&id=3c5cc3dc&scoped=true&"
import script from "./noticePage.vue?vue&type=script&lang=ts&"
export * from "./noticePage.vue?vue&type=script&lang=ts&"
import style0 from "./noticePage.vue?vue&type=style&index=0&id=3c5cc3dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5cc3dc",
  null
  
)

export default component.exports